import {renderPreviewImage} from "../../../../../webpack/modules-optimized/product-page";

document.querySelectorAll('.options[data-type="color"]').forEach(function(option) {
    renderPreviewImage(option.closest('.product-scope'), true, option.dataset.productIndex || 1);
});